"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClickOutside = void 0;
var react_1 = require("react");
var useCallback_1 = require("./useCallback");
function useClickOutside(f) {
    var ref = react_1.useRef({});
    react_1.useEffect(function () {
        var handleExternalClick = function (event) {
            var el = event.target;
            var areas = ref.current;
            var isInAreas = Object.keys(areas).some(function (k) {
                var area = areas[k];
                return area === null || area === void 0 ? void 0 : area.contains(el);
            });
            if (!isInAreas)
                f();
        };
        document.addEventListener("click", handleExternalClick);
        return function () { return document.removeEventListener("click", handleExternalClick); };
    }, [f, ref]);
    var additionalArea = useCallback_1.useCallback(function (name) { return function (el) {
        ref.current[name] = el;
    }; }, [ref]);
    var main = useCallback_1.useCallback(function (el) { return additionalArea("main")(el); }, [
        additionalArea,
    ]);
    var res = main;
    res.additionalArea = additionalArea;
    return res;
}
exports.useClickOutside = useClickOutside;
//# sourceMappingURL=useClickOutside.js.map